// extracted by mini-css-extract-plugin
module.exports = {"top_bar":"mainpage-module--top_bar--nhDLp","h2":"mainpage-module--h2--2ogFX","headingLine":"mainpage-module--headingLine--2B_Uv"};